import Header from './header.json'

export default class BillingDatatableUtils {
  nameStorage = 'billing-faturamento-header-order';

  headerDefault: any[] = [...Header];

  headerSelected: any[] = [];

  headerNotShow: any[] = ['selected', 'deleted', 'actions'];

  constructor() {
    this.loadHeaders();
  }

  get headerFirst(): any[] {
    return [
      this.headerDefault.find((h) => h.value === 'selected'),
      this.headerDefault.find((h) => h.value === 'deleted'),
    ];
  }

  get headerLast(): any[] {
    return [
      this.headerDefault.find((h) => h.value === 'actions'),
    ];
  }

  get headerFixed(): any[] {
    return this.headerDefault
      .filter((h) => h.fixed === true)
      .filter((h) => !this.headerNotShow.includes(h.value));
  }

  get headerFixedWithActions(): any[] {
    return [
      ...this.headerFirst,
      ...this.headerFixed,
      ...this.headerLast,
    ];
  }

  get headerAvailable(): any[] {
    const reorder: any[] = []
    this.headerDefault
      .filter((h) => h.fixed === false)
      .forEach((h) => {
        const found = this.headerSelected.find((hs) => hs.value === h.value);
        reorder.push(found ? { ...found, active: true } : h);
      });
    return reorder;
  }

  get headerSelectedValues(): string[] {
    if (this.headerSelected.length === 0) {
      return this.headerDefault.map((h) => h.value);
    }
    return this.headerSelected.map((h) => h.value);
  }

  saveHeaders(data: any[]) {
    const toSave = data.length ? data : this.headerSelectedValues;
    localStorage.setItem(this.nameStorage, JSON.stringify(toSave));
  }

  loadHeaders() {
    const saved = localStorage.getItem(this.nameStorage);
    if (saved) {
      const reorder: any[] = [];
      const parsed = JSON.parse(saved);
      parsed.forEach((val: string) => {
        const found = this.headerDefault.find((h) => h.value === val);
        if (found) {
          reorder.push(found);
        }
      });
      this.headerSelected = [...reorder];
      return;
    }
    this.headerSelected = this.headerFixedWithActions;
  }
}
